import { reviewFormValidator } from "@redotech/redo-form-builder-common/db-validator/review/review-form-builder-form-validator";
import * as z from "zod";

export const getActiveReviewFormForTeam = {
  name: "getActiveReviewFormForTeam" as const,
  input: z.null(),
  output: reviewFormValidator.extend({ formId: z.string() }).nullable(),
};
